import React from 'react'
import { Helmet } from 'react-helmet'

import useSiteMetadata from '../../utils/hooks/use-site-metadata'

const SiteMetadata = ({ location }: { location: { pathname: string } }) => {
  const { siteUrl, title, siteSeoImage, favicon } = useSiteMetadata()

  const href = `${siteUrl}${location.pathname}`

  return (
    <Helmet defer={false} defaultTitle={title} titleTemplate={`%s - ${title}`}>
      <html lang="en" />
      <link rel="canonical" href={href} />
      <meta name="docsearch:version" content="2.0" />
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1,maximum-scale=1, minimum-scale=1,shrink-to-fit=no,viewport-fit=cover"
      />
      <meta name="description" content="CORGI HomePlan - Boiler cover & boiler replacement" />
      <meta name="facebook-domain-verification" content="s6h8jhr0plgie2vrydk8eisc65ibxu" />
      <meta property="og:url" content={href} />
      <meta property="og:type" content="website" />
      {/* <meta property="og:locale" content={locale} /> */}
      <link rel="icon" href={favicon} />
      <meta property="og:site_name" content={title} />
      <meta property="og:image" content={siteSeoImage} />
      <meta property="og:image:alt" content="Gatsby Logo" />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
    </Helmet>
  )
}

export default SiteMetadata
